import * as yup from 'yup'
import {
  handicapOptions,
  frequencyOptions,
  proficiencyOptions,
} from './constants'
import { handednessOptions } from 'utils/constants'

const handicapValues = handicapOptions.map(option => option.value)
const frequencyValues = frequencyOptions.map(option => option.value)
const proficiencyValues = proficiencyOptions.map(option => option.value)
const handednessValues = handednessOptions.map(option => option.value)

export const combinedSchema = {
  golfInformation: yup.object({
    frequency: yup
      .string()
      .oneOf(frequencyValues)
      .nullable(),
    associatedWithCourse: yup.string().nullable(),
    homeGolfCourse: yup
      .string()
      .nullable()
      .test('require-home-course', 'This field is required', function (value) {
        const { associatedWithCourse } = this.parent
        if (associatedWithCourse === 'true') {
          return Boolean(value && value.trim() !== '')
        }
        return true
      }),
    proficiency: yup
      .string()
      .oneOf(proficiencyValues)
      .nullable(),
    ownClubs: yup.string().nullable(),
    handedness: yup
      .string()
      .oneOf(handednessValues)
      .nullable(),
    handicapRating: yup
      .string()
      .oneOf(handicapValues)
      .nullable(),
  }),
  golfFocusInformation: yup.object({
    confidentArea: yup.string().nullable(),
    improvementArea: yup.string().nullable(),
  }),
  physicalInformation: yup.object({
    heightFeet: yup
      .number()
      .nullable()
      .min(3, 'Must be a valid height')
      .max(8, 'Must be a valid height')
      .transform(value => (Number.isInteger(value) ? value : null)),
    heightInches: yup
      .number()
      .nullable()
      .min(0, 'Must be a valid height')
      .max(11, 'Must be a valid height')
      .transform(value => (Number.isInteger(value) ? value : null)),
    limitations: yup.string().nullable(),
  }),
}
